import React from 'react';
import { connect } from "react-redux";
import FreemiumCarousel from '../components/FreemiumCarousel';
import { fetchPlaylist, fetchUserPlaylist, storeHistory, fetchSonyFreePlaylist } from '../actions/playlistActions';
import rootDispatcher from '../../@packages/@bd-uikit-web/js-helpers/rootDispatcher';
import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';
import { setIsHomeFirstScreen } from './utils'
import store from 'store';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';
import Cookies from 'js-cookie';

export class Freemium extends React.Component {
  constructor(props) {
    super(props);
    var status = '';
    if (bdAuth.getToken()) {
      status = 'paired';
      this.user = store.get('auth__user') || '';
    }
    else {
      status = 'notPaired';
    }

    this.state = {
      status
    }

    this.STORE_KEYS = {
      user: 'auth__user',
      token: 'auth__token',
    };
    this.logout = this.logout.bind(this);
  }

  componentWillMount() {
    if (bdAuth.getToken()) {
      bdAuth.checkToken();
    } else {
      fetchSonyFreePlaylist(dispatch)
    }
    const { dispatch, playlist } = this.props;
    if (playlist.length == 0) {
      this.props.fetchPlaylist();
    }
    this.props.setHistory(this.props.history);
    setIsHomeFirstScreen(false);
  }

  componentDidMount() {
    if (this.state.status == 'paired') {
      this.interval = setInterval(() => this.checkSubscription(), 1000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  checkSubscription() {
    let id = this.user.id ? this.user.id : this.user || '';
    bdReq.get(`/users/${id}/subscriptions`)
      .then((response) => {
        if (response.status != 200) {
          store.remove('subscription');
          store.set('subscription', "no");
        }
        else {
          clearInterval(this.interval);
          store.remove('subscription');
          store.set('subscription', "yes");
          store.remove('description');
          store.set('description', response.body.plan.description);
          this.props.history.push('/Home');
        }
      })
  }

  logout() {
    clearInterval(this.interval);
    let userId = this.user.id ? this.user.id : this.user || '';
    const deviceId = store.get('device-id');

    bdReq.delete(`/users/${userId}/devices/${deviceId}`)
      .then((data) => {
        if (data.success) {
          store.remove('device-id');
        }
      }).catch(() => { });

    store.remove('subscription');
    store.remove('description');
    store.remove('device-id');
    store.remove('device-name');
    store.remove('art-id');
    store.remove(this.STORE_KEYS.user);
    Cookies.remove(this.STORE_KEYS.token);
    setIsHomeFirstScreen(false);
    this.setState({
      status: 'notPaired'
    })
  }

  render() {
    return (
      <div className="freemium">
        <div className="freemium__header">
          <img className="freemium__header__logo" src="https://assets.blackdove.com/images/horizontal_alternate.svg" />
          <h4 className="freemium__header__text h--no-spacing h--normalize-weight">Experience Video Art</h4>
        </div>
        <div className="freemium__body">
          <FreemiumCarousel history={this.props.history} playlist={this.props.playlist} />
        </div>
        <div className="freemium__footer text-center">
          {
            this.state.status == 'notPaired' ?
              <div className="container">
                <div className="contain__left">
                  <button
                    tabIndex="2"
                    onClick={() => {
                      this.props.history.push('/Register')
                    }}
                    className="btn btn--outlined btn--round freemium__footer__btn bttn"
                  >Join</button>
                  <h6 className="h--no-spacing">And get access to 1000's of artworks</h6>
                </div>
                <div className="contain__txt">Or</div>
                <div className="contain__right">
                  <button
                    tabIndex="3"
                    onClick={() => {
                      this.props.history.push('/pair')
                    }}
                    className="btn btn--outlined btn--round freemium__footer__btn bttn"
                  >Pair</button>
                  <h6 className="h--no-spacing">with your existing account</h6>
                </div>
              </div>
              :
              <div style={{ width: '13%', margin: '0 auto' }}>
                <button
                  tabIndex="2"
                  onClick={this.logout}
                  className="btn btn--outlined btn--round freemium__footer__btn bttn"
                >Logout</button>
              </div>
          }
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setHistory: (history) => dispatch(storeHistory(history)),
  fetchPlaylist: () => fetchPlaylist(dispatch)
});

export default connect((state) => {
  const { playlist } = state;
  return {
    playlist,
  }
}, mapDispatchToProps)(Freemium)